import Vapi from 'vuex-rest-api'
import http from 'src/http/index'
import { deleteSuccess, createSuccess, beforeRequestReset } from 'components/utils/storeUtils'

const initialState = () => ({
  vessels: null,
  vessel: {},
  vessel_ruimte: {},
  vessel_ruimten: null,
  inventarisatie_ruimtes: null,
  inventarisatie_ruimte: {},
  plattegronden: null,
  vessel_plattegronden: null,
  vessel_plattegrond: {},
  vessel_photos: null,
  vessel_photo: null,
  vessel_templates: null,
  vessel_template: {},
  vessel_template_ruimten: null,
  vessel_template_ruimte: {}
})

const vesselDepKeys = ['ruimte', 'vessel_plattegrond', 'vessel_vessel_ruimten', 'inventarisatie_ruimtes', 'vessel_plattegronden', 'vessel_photos', 'vessel_photo']

const templateDepKeys = ['vessel_template_ruimten', 'vessel_template_ruimte']

const vastgoed = new Vapi({
  axios: http.axios,
  baseURL: process.env.API_URL + '/maritime',
  queryParams: true,
  state: initialState()
})
  .get({
    action: 'GET_VESSELS',
    property: 'vessels',
    queryParams: true,
    path: '/vessel',
    beforeRequest: beforeRequestReset('vessel', ['vessel'], initialState())
  })
  .get({
    action: 'UPDATE_VESSEL_WITH_VESSELTRACKER',
    property: 'vessel_tracker_vessel',
    queryParams: true,
    path: ({ id }) => `/vessel_tracker_vessel/${id}/update`
  })
  .get({
    action: 'GET_VESSEL',
    property: 'vessel',
    queryParams: true,
    path: ({ id }) => `/vessel/${id}`,
    beforeRequest: beforeRequestReset('vessel', vesselDepKeys, initialState())
  })
  .post({
    action: 'CREATE_VESSEL',
    property: 'vessel',
    path: '/vessel',
    onSuccess: createSuccess('vessel', 'vessels')
  })
  .post({
    action: 'UPDATE_VESSEL',
    property: 'vessel',
    path: ({ id }) => `/vessel/${id}`
  })
  .delete({
    action: 'DELETE_VESSEL',
    property: 'vessel',
    queryParams: true,
    path: ({ id }) => `/vessel/${id}`,
    onSuccess: deleteSuccess('vessel', 'vessels')
  })
  .get({
    action: 'GET_INVENTARISATIE_RUIMTEN_FROM_VESSEL',
    queryParams: true,
    property: 'inventarisatie_ruimtes',
    path: ({ vesselId }) => `/vessel/${vesselId}/vessel_ruimten/inventarisatie_ruimte`,
    beforeRequest: beforeRequestReset('inventarisatie_ruimte', ['inventarisatie_ruimte'], initialState())
  })
  .get({
    action: 'GET_VESSEL_RUIMTEN',
    queryParams: true,
    property: 'vessel_ruimten',
    path: '/vessel_ruimte',
    beforeRequest: beforeRequestReset('vessel_ruimte', ['vessel_ruimte'], initialState())
  })
  .get({
    action: 'GET_VESSEL_RUIMTEN_FROM_VESSEL',
    queryParams: true,
    property: 'vessel_ruimten',
    path: ({ vesselId }) => `/vessel/${vesselId}/vessel_ruimten`,
    beforeRequest: beforeRequestReset('vessel_ruimte', ['vessel_ruimte'], initialState())
  })
  .get({
    action: 'GET_VESSEL_RUIMTE',
    property: 'vessel_ruimte',
    queryParams: true,
    path: ({ id }) => `/vessel_ruimte/${id}`
  })
  .post({
    action: 'CREATE_VESSEL_RUIMTE',
    property: 'vessel_ruimte',
    path: '/vessel_ruimte',
    onSuccess: createSuccess('vessel_ruimte', 'vessel_ruimten')
  })
  .post({
    action: 'UPDATE_VESSEL_RUIMTE',
    property: 'vessel_ruimte',
    path: ({ id }) => `/vessel_ruimte/${id}`
  })
  .delete({
    action: 'DELETE_VESSEL_RUIMTE',
    property: 'vessel_ruimte',
    requestConfig: {
      headers: {
        'X-Strmln-Forced-Delete': true
      }
    },
    queryParams: true,
    path: ({ id }) => `/vessel_ruimte/${id}`,
    onSuccess: deleteSuccess('vessel_ruimte', 'vessel_ruimten')
  })
  .get({
    action: 'GET_VESSEL_PLATTEGRONDEN_FROM_VESSEL',
    queryParams: true,
    property: 'vessel_plattegronden',
    path: ({ vesselId }) => `/vessel/${vesselId}/vessel_plattegronden`,
    beforeRequest: beforeRequestReset('vessel_plattegrond', ['vessel_plattegrond'], initialState())
  })
  .get({
    action: 'GET_VESSEL_PLATTEGROND',
    property: 'vessel_plattegrond',
    queryParams: true,
    path: ({ id }) => `/vessel_plattegrond/${id}`
  })
  .post({
    action: 'CREATE_VESSEL_PLATTEGROND',
    property: 'vessel_plattegrond',
    path: '/vessel_plattegrond',
    onSuccess: createSuccess('vessel_plattegrond', 'vessel_plattegronden')
  })
  .post({
    action: 'UPDATE_VESSEL_PLATTEGROND',
    property: 'vessel_plattegrond',
    path: ({ id }) => `/vessel_plattegrond/${id}`
  })
  .delete({
    action: 'DELETE_VESSEL_PLATTEGROND',
    property: 'vessel_plattegrond',
    queryParams: true,
    path: ({ id }) => `/vessel_plattegrond/${id}`,
    onSuccess: deleteSuccess('vessel_plattegrond', 'vessel_plattegronds')
  })
  .get({
    action: 'GET_VESSEL_PHOTOS_FROM_VESSEL',
    queryParams: true,
    property: 'vessel_photos',
    path: ({ vesselId }) => `/vessel/${vesselId}/vessel_photos`,
    beforeRequest: beforeRequestReset('vessel_photo', ['vessel_photo'], initialState())
  })
  .get({
    action: 'GET_VESSEL_PHOTO',
    property: 'vessel_photo',
    queryParams: true,
    path: ({ id }) => `/vessel_photo/${id}`
  })
  .post({
    action: 'CREATE_VESSEL_PHOTO',
    property: 'vessel_photo',
    path: '/vessel_photo',
    onSuccess: createSuccess('vessel_photo', 'vessel_photos')
  })
  .post({
    action: 'UPDATE_VESSEL_PHOTO',
    property: 'vessel_photo',
    path: ({ id }) => `/vessel_photo/${id}`
  })
  .delete({
    action: 'DELETE_VESSEL_PHOTO',
    property: 'vessel_photo',
    queryParams: true,
    path: ({ id }) => `/vessel_photo/${id}`,
    onSuccess: deleteSuccess('vessel_photo', 'vessel_photos')
  })
  .get({
    action: 'GET_VESSEL_TEMPLATES',
    property: 'vessel_templates',
    queryParams: true,
    path: '/vessel_template',
    beforeRequest: beforeRequestReset('vessel_template', ['vessel_template'], initialState())
  })
  .get({
    action: 'GET_VESSEL_TEMPLATE',
    property: 'vessel_template',
    queryParams: true,
    path: ({ id }) => `/vessel_template/${id}`,
    beforeRequest: beforeRequestReset('vessel_template', templateDepKeys, initialState())
  })
  .post({
    action: 'CREATE_VESSEL_TEMPLATE',
    property: 'vessel_template',
    path: '/vessel_template',
    queryParams: true,
    onSuccess: createSuccess('vessel_template', 'vessel_templates')
  })
  .post({
    action: 'UPDATE_VESSEL_TEMPLATE',
    property: 'vessel_template',
    queryParams: true,
    path: ({ id }) => `/vessel_template/${id}`
  })
  .delete({
    action: 'DELETE_VESSEL_TEMPLATE',
    property: 'vessel_template',
    queryParams: true,
    path: ({ id }) => `/vessel_template/${id}`,
    beforeRequest: beforeRequestReset('vessel_template', templateDepKeys, initialState()),
    onSuccess: deleteSuccess('vessel_template', 'vessel_templates')
  })
  .get({
    action: 'GET_VESSEL_RUIMTEN_FROM_TEMPLATE',
    queryParams: true,
    property: 'vessel_template_ruimten',
    path: ({ templateId }) => `/vessel_template/${templateId}/vessel_template_ruimten`,
    beforeRequest: beforeRequestReset('vessel_template_ruimte', ['vessel_template_ruimte'], initialState())
  })
  .get({
    action: 'GET_VESSEL_TEMPLATE_RUIMTE',
    property: 'vessel_template_ruimte',
    queryParams: true,
    path: ({ id }) => `/vessel_template_ruimte/${id}`
  })
  .post({
    action: 'CREATE_VESSEL_TEMPLATE_RUIMTE',
    property: 'vessel_template_ruimte',
    path: '/vessel_template_ruimte',
    queryParams: true,
    onSuccess: createSuccess('vessel_template_ruimte', 'vessel_template_ruimten')
  })
  .post({
    action: 'UPDATE_VESSEL_TEMPLATE_RUIMTE',
    property: 'vessel_template_ruimte',
    queryParams: true,
    path: ({ id }) => `/vessel_template_ruimte/${id}`
  })
  .delete({
    action: 'DELETE_VESSEL_TEMPLATE_RUIMTE',
    property: 'vessel_template_ruimte',
    queryParams: true,
    path: ({ id }) => `/vessel_template_ruimte/${id}`,
    onSuccess: deleteSuccess('vessel_template_ruimte', 'vessel_template_ruimtes')
  })
  .getStore()

vastgoed.mutations.RESET_MARITIME_STATE = (state) => {
  const initial = initialState()
  for (const key in state) {
    if (Object.prototype.hasOwnProperty.call(state, key)) {
      state[key] = initial[key]
    }
  }
}

export default vastgoed
